import React, { useState } from "react";

import {
  Hits,
  Pagination,
  SearchBox,
  HierarchicalMenu,
  CurrentRefinements,
  SortBy,
} from "react-instantsearch-hooks-web";

import { Panel } from "./components/Panel";
import { SelectMenu } from "./components/SelectMenu";
import { Item } from "./components/Item";
import { ScrollTo } from "./components/ScrollTo";
import { TuneIcon } from "./icons/TuneIcon";
import { ShowAllButton } from "./components/ShowAllButton";
import { NoResultsBoundary } from "./components/NoResultsBoundary";
import { NoResults } from "./components/NoResults";
import { FilterMenu } from "./components/FilterMenu";

function App() {
  const [showMobileFilters, setShowMobileFilters] = useState(false);

  return (
    <div className="relative lg:flex w-full p-0 lg:space-x-8">
      {/* FILTERS */}
      <div
        onClick={() => setShowMobileFilters(false)}
        className={`z-10 top-0 left-0 right-0 bottom-0 absolute lg:block lg:relative bg-black/25 ${
          !showMobileFilters && "hidden"
        }`}
      >
        <div
          onClick={(e) => e.stopPropagation()}
          className="relative shadow-xl lg:shadow-none  w-3/4 h-full min-h-screen lg:w-[220px] lg:min-w-[220px] bg-white px-4 lg:px-0 pt-4"
        >
          <div className=" flex justify-between items-center border-b">
            <div className="ais-Panel-header text-base">FILTERS</div>
            <ShowAllButton setShowMobileFilters={setShowMobileFilters} />
          </div>
          <hr className="mb-3 bg-gray-100" />
          <Panel header="Category">
            <HierarchicalMenu attributes={["category.lvl0", "category.lvl1"]} />
          </Panel>
          <Panel header="Year">
            <SelectMenu
              attribute="Year"
              label="Year"
              limit={30}
              transformItems={(items) =>
                items.sort((a, b) => Number(b.value) - Number(a.value))
              }
            />
          </Panel>
          <Panel header="Make">
            <FilterMenu
              attribute="Make"
              showMore={true}
              limit={15}
              showMoreLimit={30}
            />
          </Panel>
          <Panel header="Model">
            <FilterMenu
              attribute="Model"
              searchable={true}
              showMore={true}
              searchablePlaceholder="Search boat models"
              limit={15}
              showMoreLimit={30}
            />
          </Panel>
          <Panel header="Tower">
            <FilterMenu
              attribute="Tower"
              searchable={true}
              showMore={true}
              searchablePlaceholder="Search boat towers"
              limit={15}
              showMoreLimit={30}
            />
          </Panel>
          <div className="fixed lg:hidden bg-white bottom-0 left-0 w-3/4 p-2">
            <button
              onClick={() => setShowMobileFilters(false)}
              className="block w-full"
            >
              View Results
            </button>
          </div>
        </div>
      </div>

      {/* MAIN CONTENT */}
      <div className="flex-grow">
        <div></div>
        <div className="lg:flex lg:space-x-4 pb-4 justify-between items-end">
          <div className="hidden lg:block">
            <CurrentRefinements
              classNames={{ list: "flex flex-wrap" }}
              transformItems={(items) => {
                return items.map((item) => {
                  const label = item.label.startsWith("category")
                    ? `Category`
                    : item.label;
                  return {
                    ...item,
                    label,
                  };
                });
              }}
            />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <button
              className="py-1 lg:hidden flex space-x-2 items-center justify-center bg-white border-gray-300 border rounded shadow-sm text-black"
              onClick={() => setShowMobileFilters(true)}
            >
              <TuneIcon className="w-6" />
              <span className="">Filters</span>
            </button>
            <SortBy
              classNames={{
                select: "h-14 lg:h-10 py-0 pl-3",
              }}
              items={[
                { label: "Relevance", value: "products" },
                { label: "Price: Low to High", value: "priceMin_asc" },
                { label: "Price: Hight to Low", value: "priceMax_desc" },
              ]}
            />
            <SearchBox
              className="col-span-2 lg:col-span-1"
              placeholder="Search"
            />
          </div>
        </div>

        <ScrollTo>
          <div className="pb-4">
            <NoResultsBoundary
              fallback={
                <NoResults setShowMobileFilters={setShowMobileFilters} />
              }
            >
              <Hits hitComponent={Item} />
            </NoResultsBoundary>
          </div>
        </ScrollTo>
        <Pagination className="mt-4 Pagination" />
      </div>
    </div>
  );
}

export default App;
